module.exports = __webpack_public_path__ + "img/speech_1.7297684f.jpeg";